import React from 'react';
import { Container, Row } from 'react-bootstrap';
import styled from 'styled-components';
import { colorBackgroundBody } from '@/utils/palette';
import * as Imports from './mainFileImports';
import { useSelector } from 'react-redux';

const MemoizedSidebar = () => {
  const { Layout, AlertNotifications, StaticAlertNotifications, Breadcrumb, breadcrumbs } = Imports;
  const customerOnboarded = useSelector((state) => state?.auth?.currentUser?.customerOnboarded);
  return (
    <>
      <Layout />
      <ContainerWrap>
        <Container>
          <AlertNotifications />
          <StaticAlertNotifications />
        </Container>
        {customerOnboarded === true && (
          <Container>
            <Row style={{ paddingBottom: '20px' }}>
              <Breadcrumb breadcrumbs={breadcrumbs} />
            </Row>
          </Container>
        )}
      </ContainerWrap>
    </>
  );
};

export default MemoizedSidebar;

const ContainerWrap = styled.div`
  padding-top: 90px;
  transition: padding-left 0.3s;
  padding-left: 0;
  background: ${colorBackgroundBody};
  @media screen and (min-width: 576px) {
    padding-left: ${({ collapse }) => (collapse ? '60px' : '250px')};
  }
  @media screen and (max-width: 576px) {
    padding-top: 150px;
  }
`;
